// ZB Before/After Image Slider

(function () {
  function initSlider(root) {
    var slider = root.querySelector('[data-ba-slider]');
    if (!slider) return;

    var range = slider.querySelector('[data-ba-range]');
    if (!range) return;

    function updatePosition(value) {
      slider.style.setProperty('--zb-ba-initial', value + '%');
    }

    range.addEventListener('input', function () {
      updatePosition(range.value);
    });

    // Initialize once on load in case the browser restores a cached range value
    updatePosition(range.value);
  }

  function initAll() {
    document.querySelectorAll('.zb-ba').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.zb-ba');
    if (root) initSlider(root);
  });
})();